import { createReducerFromMap, createAsyncReducer, createDefaultInitialState } from "@coverme/redux";

const initialState = createDefaultInitialState([]);

const onGetEligibleProgramsSuccess = (state, action) => {
    const programCards = action.value;
    const programs = programCards.map(x => {
        const mappedCard = {
            ...x,
            programId: x.programId,
            name: x.programName,
            details: x.details.reduce((acc, cur) => {
                acc[cur.key] = cur.value;
                return acc;
            }, {}),
        };

        if (mappedCard.details?.Title?.indexOf("Medicaid") >= 0 || mappedCard.details?.Title?.indexOf("SoonerCare") >= 0) {
            mappedCard.details.SubTitle = x.assistanceCategory;
        }

        return mappedCard;
    });
    return programs;
};

const resetPrograms = (state, action) => initialState;

export const programReducer = createReducerFromMap(initialState, {
    ...createAsyncReducer("GET_ELIGIBLE_PROGRAMS", onGetEligibleProgramsSuccess),
    RESET_PROGRAMS: resetPrograms,
    // ...createAsyncReducer("DENY_PROGRAM", onDenyProgram),
});
